import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { OrganizationData, ResearcherInviteData, type UserData } from '../../types'
import { authApi } from '../api/authApi'

export interface AuthState {
  user: UserData | null
  organization: OrganizationData | null
  token: string | null
  researcherInviteData: ResearcherInviteData | null
}

const initialState: AuthState = {
  user: null,
  organization: null,
  token: null,
  researcherInviteData: null,
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserData>) => {
      state.user = action.payload
    },
    setOrganization: (state, action: PayloadAction<OrganizationData>) => {
      state.organization = action.payload
    },
    restoreAuthState: (state) => {
      const token = localStorage.getItem('token')
      state.token = token

      try {
        const userString = localStorage.getItem('user')

        if (userString) {
          const user = JSON.parse(userString)
          state.user = user
        }
      } catch (e) {
        console.warn(e)
      }

      try {
        const organizationString = localStorage.getItem('organization')

        if (organizationString) {
          const organization = JSON.parse(organizationString)
          state.organization = organization
        }
      } catch (e) {
        console.warn(e)
      }
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload
    },
    clearAuthState: (state) => {
      state.token = null
      state.user = null
      state.organization = null
      localStorage.clear()
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(authApi.endpoints.loginUser.matchFulfilled, (state, { payload }) => {
      state.user = payload.dto
      state.organization = payload.organization
      state.token = payload.token

      localStorage.setItem('token', payload.token)
      localStorage.setItem('user', JSON.stringify(payload.dto))
      localStorage.setItem('organization', JSON.stringify(payload.organization))
    })

    builder.addMatcher(authApi.endpoints.getInviteRequestDataByToken.matchFulfilled, (state, { payload }) => {
      state.researcherInviteData = payload
    })
  },
})

// Action creators are generated for each case reducer function
export const { setUser, setToken, restoreAuthState, clearAuthState } = authSlice.actions

export default authSlice.reducer
